import { randomFloat, randomInteger, randomString, randomUUID, randomWords } from 'utils/random';
import titleCase from 'utils/title-case';
import {
  BestMixFeed,
  ManualFeed,
  ScenarioFeedProgram,
} from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-feed-program.type';

/**
 * Generates an array of random ManualFeed objects.
 *
 * @returns {ManualFeed[]} A randomly generated ManualFeed object array.
 */
function getRandomManualFeeds(): ManualFeed[] {
  return Array.from({ length: randomInteger(4) + 1 }, () => ({
    feedId: randomUUID(),
    name: titleCase(randomWords(5)),
    fishSizeStart: Math.round(randomFloat(5000, 0) / 100) * 100,
    price: Math.round(randomFloat(200, 2) / 100) * 100,
  })).sort((a, b) => a.fishSizeStart - b.fishSizeStart); // Sort feeds by fish size for realism
}

/**
 * Generates an array of random BestMixFeed objects.
 *
 * @returns {BestMixFeed[]} A randomly generated BestMixFeed object array.
 */
function getRandomBestMixFeeds(): BestMixFeed[] {
  return Array.from({ length: randomInteger(4) + 1 }, () => ({
    productCode: randomString(8),
    name: titleCase(randomWords(5)),
    fishSizeStart: Math.round(randomFloat(5000, 0) / 100) * 100,
    price: Math.round(randomFloat(200, 2) / 100) * 100,
  })).sort((a, b) => a.fishSizeStart - b.fishSizeStart); // Sort feeds by fish size for realism
}

/**
 * Generates an array of random FeedProgram objects.
 *
 * @param count The number of feed programs to generate. Defaults to 3.
 * @returns {ScenarioFeedProgram[]} A randomly generated FeedProgram object array.
 */
function getRandomFeedProgram(count = 3): ScenarioFeedProgram[] {
  return Array.from({ length: count }, () => ({
    id: randomUUID(),
    name: titleCase(randomWords(3)),
    manualFeeds: getRandomManualFeeds(),
    bestMixFeeds: getRandomBestMixFeeds(),
  }));
}

export const mockFeedPrograms: ScenarioFeedProgram[] = getRandomFeedProgram(3);

const mockFeedProgram: ScenarioFeedProgram = mockFeedPrograms[0];

export default mockFeedProgram;
